import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  const { fill = "black" } = props;
  return (
    <Svg
      {...props}
      width={8}
      height={10}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M3.636 8.96a.662.662 0 01-.008-.112v-6.35l-.062.139a1.288 1.288 0 01-.25.364l-1.73 1.78a.634.634 0 01-.83.094.656.656 0 01-.081-.966L3.803.689a.613.613 0 01.885 0l3.13 3.22a.657.657 0 01-.063.966.634.634 0 01-.83-.094L5.193 3.004a1.287 1.287 0 01-.228-.322l-.084-.193v6.323a.663.663 0 01-.526.68.628.628 0 01-.718-.533z"
        fill={fill}
      />
    </Svg>
  );
}

export default SvgComponent;
